import { cn } from '@/lib/utils';

export interface SkeletonProps {
  className?: string;
}

/**
 * Loading placeholder. Used instead of a spinner wherever we know the shape of
 * what is coming, so the layout does not jump when data arrives.
 */
export function Skeleton({ className }: SkeletonProps) {
  return <span className={cn('block animate-pulse rounded-field bg-surface-2', className)} aria-hidden />;
}

/** A block of stacked lines — the common case inside cards and table cells. */
export function SkeletonLines({ count = 3, className }: { count?: number; className?: string }) {
  return (
    <div className={cn('flex flex-col gap-2', className)} role="status" aria-label="Loading">
      {Array.from({ length: count }, (_, index) => (
        <Skeleton key={index} className={cn('h-3.5', index === count - 1 ? 'w-2/3' : 'w-full')} />
      ))}
    </div>
  );
}
